import ModalComponent from 'v3/common/components/Modal';
import { AlgoverseDeploymentCostModalProps, DEPLOYMENT_STATUS } from './types.type';
import { useDeploymentGuard } from './hook/useAlgoverseDeployGuard';
import { getModalConfig } from './modalConfig';

const AlgoverseDeploymentCostModal: React.FC<AlgoverseDeploymentCostModalProps> = (props) => {
  // eslint-disable-next-line react/prop-types
  const { isOpen, onClose, onSave, isPremium } = props;
  const { isLoading, isStrategyDeployBlocked } = useDeploymentGuard();

  const status = isLoading
    ? DEPLOYMENT_STATUS.LOADING
    : isStrategyDeployBlocked
      ? DEPLOYMENT_STATUS.INSUFFICIENT_FUNDS
      : DEPLOYMENT_STATUS.CONFIRMATION;

  const current = getModalConfig({ status, isPremium, onClose, onSave });

  return (
    <ModalComponent isOpen={isOpen} onClose={onClose}>
      <div className="deploy-confirmation-modal">
        <div className="deploy-confirmation-modal__header">
          <div className="icon-container">
            <i className="fa-regular fa-circle-info" />
          </div>
          <h1>{current.title}</h1>
        </div>

        <div className="deploy-confirmation-modal__body">{current.body}</div>

        <div className="deploy-confirmation-modal__footer btn-groups">{current.footer}</div>
      </div>
    </ModalComponent>
  );
};

export default AlgoverseDeploymentCostModal;
